import { symbol } from "./icons/ebay-image-placeholder/symbol.js";
<ebay-icon ...input _name="image-placeholder" _type="image-placeholder" _themes=symbol/>